export default {
  withCOB: {
    lg: 2,
    md: 6,
    sm: 6,
    xs: 12
  },
  withoutCOB: {
    lg: 3,
    md: 4,
    sm: 4,
    xs: 12
  },
  button: {
    lg: 4,
    md: 9,
    sm: 12,
    xs: 12
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/claim-expenses-columns.js